if (typeof BSS_B2B !== 'undefined' && BSS_B2B && (window.location.pathname == '/pages/zeades-customer-registration' || window.location.pathname == '/pages/zeades-b2b-partner-portal')) {
  $("#RegisterForm-password").attr("placeholder", 'Password')
  const formWholesaleEle = $('#RegisterForm');
  
  const checkInputsInterval = setInterval(function() {
    const inputFormElements = formWholesaleEle.find('input:not([type="button"]):not([type="hidden"])');
    
    if (inputFormElements.length > 0) {
      clearInterval(checkInputsInterval); 
      inputFormElements.each(function() {
        const inputElement = $(this);
        const labelElement = inputElement.parent().find('label');
        
        if (labelElement.length > 0) {
          inputElement.attr('placeholder', labelElement.text());
  
          inputElement.on("change keyup paste", function() {
            if ($(this).val() !== '') {
              labelElement.css('opacity', 1);
              labelElement.css('transform', 'translateY(0)')
            } else {
              labelElement.css('opacity', 0);
              labelElement.css('transform', 'translateY(3px)')
            }
          });
        }
      });
    }
  }, 100);
}